module.exports = __webpack_public_path__ + "img/btn_cancel.9ab9ac16.png";